import {SectionBgView} from '../../../shared/scripts/ui_canvas_engine/SectionBgView'
import {UIGameStateController} from '../../../shared/scripts/ui_game/UIGameStateController'
import {TranslationObject} from '@colonist/i18n'
import {TextTruncatedView} from '../../../shared/scripts/ui_canvas_engine/TextTruncatedView'
import {GameColor} from '../../../shared/scripts/GameColor'
import {GameFont} from '../../../shared/scripts/GameFont'
import {UIGameSpriteHandler} from '../../../shared/scripts/UIGameSpriteHandler'
import {Sprites} from '../../../shared/scripts/ui_game/UIGameImageDictionary'
import {UIGamePlayerAvatarView} from '../../../shared/scripts/ui_game/ui_game_players/UIGamePlayerAvatarView'
import {SpriteView} from '../../../shared/scripts/ui_canvas_engine/SpriteView'

export class UIMGameStateController extends UIGameStateController {
    protected createContainer() {
        const canvas = this.uiGameManager.canvasController
        const x = 0
        const y = this.uiGameManager.gameLayout.getStateControllerY()
        const w = canvas.appW
        const h = this.uiGameManager.gameLayout.getStateControllerHeight()
        this.container = new SectionBgView(x, y, w, h, canvas.app.stage, true)
        this.container.drawBg(GameColor.getColorHexValue(GameColor.Color.PrimaryBlue5), 1, 0, 0, 0, 0)
        this.container.interactive = true
        this.createPlayerAvatar()
        this.createStateText()
    }

    private createPlayerAvatar() {
        const currentTurnPlayerState = this.uiGameManager.gameController.getPlayerState(this.uiGameManager.gameController.currentState.currentTurnPlayerColor)
        const height = this.container.height * 0.8
        const y = (this.container.height - height) / 2
        this.singlePlayerAvatar = new UIGamePlayerAvatarView(0, y, height, this.container, currentTurnPlayerState)
        this.singlePlayerAvatar.updatePlayerIcon(UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_bot))

        this.multiPlayerIcon = new SpriteView(0, y, height, height, this.container, UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_players))
    }

    private createStateText() {
        const placeHolderText: TranslationObject = {key: 'strings:colonistCommon.utils.emptyString'}
        const stateTextX = this.singlePlayerAvatar.x + this.singlePlayerAvatar.width
        const stateTextW = this.container.width - stateTextX
        this.stateText = new TextTruncatedView(placeHolderText, stateTextX, 0, stateTextW, this.container.height, this.container, GameFont.Size.L, GameColor.getColor(GameColor.Color.White))
    }

    protected updateText(text: TranslationObject) {
        super.updateText(text)
        const canvas = this.uiGameManager.canvasController
        this.singlePlayerAvatar.x = this.stateText.x - this.singlePlayerAvatar.width - canvas.itemSize * 0.25
    }
}
